/**
 * Phase 67-01 D-04 touchpoint 1 — fleet-wide stale-kiosk badge in Topbar.
 *
 * Renders nothing when zero stale (queryByTestId('stale-badge') === null).
 * Renders "<n> stale" with warning icon when at least one kiosk's
 * last_seen_at > 15min while is_online=true.
 */

import { AlertTriangle } from "lucide-react";

import { useStaleKiosks } from "@/hooks/queries/useStaleKiosks";

export default function StaleBadge() {
  const { data, isLoading } = useStaleKiosks();
  if (isLoading || !data || data.length === 0) return null;

  return (
    <div
      data-testid="stale-badge"
      className="flex items-center gap-1 px-2 py-1 rounded-md
                 bg-yellow-100 text-yellow-900 dark:bg-yellow-900/30
                 dark:text-yellow-200 text-xs font-medium"
      title={`${data.length} kiosk in stato 'stale' (>15 min senza heartbeat)`}
    >
      <AlertTriangle className="w-3.5 h-3.5" />
      <span>{data.length} stale</span>
    </div>
  );
}
